// marker laden
document.addEventListener("DOMContentLoaded", function(event) { 

    // const markerTimestamp = localStorage.getItem('markers-loaded');
    // const now = moment();

    // let useStorage = true;

    // if (markerTimestamp === null) {
    //     localStorage.setItem('markers-loaded', now.valueOf().toString());        
    // } else {

    // }

    const markersStorage = localStorage.getItem('markers');
    const maps = document.getElementsByClassName('locationMap');

    for (var i = 0, len = maps.length; i < len; i++) {
    
        const map = maps[i];            
        let markers = []; 
                
        const id = map.dataset.id;            
        const wrapper = document.getElementById(`locations-${id}`);    
        const locationItems = wrapper.getElementsByClassName('locationItem');        

        if(markersStorage != null && locationItems.length == JSON.parse(markersStorage).length) {        
            // console.log('marker aus storage');
            markers = JSON.parse(markersStorage);
            initMap(markers, id);
        } else {
            // console.log('marker laden');
            fetchLocation(0, locationItems, markers, id);
        }        
    }
});

// marker von Mapbox holen falls sie nicht im storage liegen
function fetchLocation(i, locationItems, markers, id) {
    console.log('fetchLocation');
    const token = 'pk.eyJ1IjoiaGVycmxpY2gtbWVkaWEiLCJhIjoiY2p0dTU4ZDRrMHBxbjQ0bXBlM3NjOTN5ayJ9.JS1FNS6PTcpcMlj_pHfVYQ';
    var jsonUrl = `https://api.mapbox.com/geocoding/v5/mapbox.places/${locationItems[i].dataset.address}.json?access_token=${token}`;

    fetch(jsonUrl).then((response) => response.json()).then((data) => {

        var tempObj = {
            'props' : data.features[0],
            'center' : data.features[0].center,
            'name' : locationItems[i].dataset.name,
            'image' : locationItems[i].dataset.img,
            'id' : locationItems[i].dataset.id
        }

        markers.push(tempObj);
        
        if(locationItems.length > i+1) {
            fetchLocation(i+1, locationItems, markers, id);                
        }else{                
            localStorage.setItem('markers', JSON.stringify(markers));
            initMap(markers, id);
        } 

    }).catch((error) => {
        console.log(error);
        if(locationItems.length > i+1) {
            fetchLocation(i+1, locationItems, markers, id);
        }else{
            
            localStorage.setItem('markers', JSON.stringify(markers));
            initMap(markers, id);
        } 
    });
}



function initMap(markers, id) {    
    mapboxgl.accessToken = 'pk.eyJ1IjoiaGVycmxpY2gtbWVkaWEiLCJhIjoiY2p0dTU4ZDRrMHBxbjQ0bXBlM3NjOTN5ayJ9.JS1FNS6PTcpcMlj_pHfVYQ';

    const initializedMap = new mapboxgl.Map({
        container: `map-${id}`, // container ID
        style: 'mapbox://styles/herrlich-media/clbdryfht002814oztxmpigmq',
        center: [6.5, 52], // starting position [lng, lat]
        zoom: 5, // starting zoom
    });

    const wrapper = document.getElementById(`locations-${id}`);    
    const type = wrapper.dataset.type;

    initializedMap.scrollZoom.disable();

    for(var i = 0; i < markers.length; i++){

        var el = document.createElement('div');
        // el.id = `marker-${id}-${markers[i].id}`;
        el.dataset.name = markers[i].name;
        el.className = 'marker';

        var marker = new mapboxgl.Marker(el)
            .setLngLat([markers[i].center[0], markers[i].center[1]])
            .addTo(initializedMap);

         el.addEventListener('click', (e) => {

            for (let i = 0; i < markers.length; i++) {
                
                if (e.target.dataset.name === markers[i].name) {
                    console.log('marker found');
                    flyToStore(markers[i], initializedMap);
                    
                    
                    if(type == 'list' && window.innerWidth >= 1000 ) {
                        createPopUp(markers[i], 'click', initializedMap, wrapper, true);

                        const toggleTriggers = wrapper.querySelectorAll('.locationToggle');
                        for (let a = 0; a < toggleTriggers.length; a++) {
                            
                            if (toggleTriggers[a].dataset.name === markers[i].name) {
                                console.log('trigger gefunden');
                                doToggles(wrapper, toggleTriggers[a]);
                            }
                        }
                    } else {
                        // slider 
                    }
                }
            }
        });

    }


    if(type == 'carousel' || type == 'list' && window.innerWidth < 1000 ) {
        
        const locationSwiper = new Swiper(`#locations-${id} .locationSwiper`, {    
            allowTouchMove: true,
            slidesPerView: 1,
            spaceBetween: 32,
            autoHeight: true,
            loop: true,
            // Responsive breakpoints
            breakpoints: {
                480: {
                    slidesPerView: 2
                }
            },
            navigation: {
                nextEl: `#locations-${id} .locationSwiper .swiper-button-next`,
                prevEl: `#locations-${id} .locationSwiper .swiper-button-prev`,
            }  
        });
        
        console.log(locationSwiper);

        locationSwiper.on('slideChange', () => {
            console.log('slide changed');
            const index = locationSwiper.realIndex;
            
            const slide = locationSwiper.slides[locationSwiper.activeIndex];
            const toggleTriggers = slide.querySelectorAll('.locationToggle');
            const name = toggleTriggers[0].dataset.name;
            console.log('name', name);

            for (let i = 0; i < markers.length; i++) {
                
                if (name === markers[i].name) {
                    console.log('marker found');
                    flyToStore(markers[i], initializedMap);                    
                    createPopUp(markers[i], 'click', initializedMap, wrapper, false);
                }
            }
        });
        console.log('open first');
        flyToStore(markers[0], initializedMap);
        createPopUp(markers[0], 'click', initializedMap, wrapper, false);

    } else if(type == 'list') {
                
        const toggleTriggers = wrapper.querySelectorAll('.locationToggle');

        if (toggleTriggers && toggleTriggers.length) {
            toggleTriggers.forEach((totr) => {

                if(totr.parentNode.classList.contains("open")) {
                    console.log('einer soll schon offen sein');
                    console.log(totr.dataset.name);
                    openMarker(markers, totr.dataset.name, initializedMap, wrapper, false);
                }

                totr.addEventListener('click', (e) => {
                    e.preventDefault();

                    doToggles(wrapper, totr);
                    openMarker(markers, totr.dataset.name, initializedMap, wrapper, true);
                });

            });
        }


    }
}

function openMarker(markers, name, map, wrapper, flyto) {
    console.log(markers);
    console.log(name);
    for (var i = 0; i < markers.length; i++) {                    
        if (name === markers[i].name) {
            var clickedListing = markers[i];
            console.log('marker clicked');
            console.log(markers[i]);

            if(flyto == true) {
                flyToStore(clickedListing, map);
            }
            createPopUp(clickedListing, 'click', map, wrapper, true);
        }
    }
}

function doToggles(wrapper, totr) {
    const openToggle = wrapper.querySelectorAll('.toggleItem.open');

    if (openToggle && openToggle.length) {
        openToggle.forEach((t) => {
            t.classList.remove('open');                        
        });
    }

    const toggleItem = totr.closest(".toggleItem");
    toggleItem.classList.toggle('open');
    toggleItemContent = totr.nextElementSibling;
}

function createPopUp(currentFeature, trigger, map, wrapper, content) {
    console.log('hier1');
    var popUps = wrapper.getElementsByClassName('mapboxgl-popup');

    var nameHtml = '';
    var imageHtml = '';

    if(content == true) {
        console.log('hier2');
        if (currentFeature.image) {
            imageHtml = `<img src="${currentFeature.image}" alt="">`;
        }
        if (currentFeature.name) {
            nameHtml = `<h3>${currentFeature.name}</h3>`;
        }
        var popupHtml = `${imageHtml}${nameHtml}<div class="popupDot"></div>`;

    } else {
        var popupHtml = `<div class="popupDot"></div>`;
    }

    console.log(popupHtml);
    
    if (popUps[0]){
        for(let i = 0; i < popUps.length; i++){
            if(trigger === 'click'){
                popUps[i].remove();
            }
        }
    }
    new mapboxgl.Popup({ closeOnClick: false, anchor: 'bottom-right' })
        .setLngLat(currentFeature.props.geometry.coordinates)
        .setHTML(popupHtml)
        .addTo(map);    
}

function flyToStore(currentFeature, map) {
    console.log('flyto');
    map.flyTo({
        center: currentFeature.props.geometry.coordinates,
        zoom: 5,
    });
}